import React, { Component } from "react";
import { View, Alert, Image, Text, ScrollView } from "react-native";
import { ButtonGroup } from "react-native-elements";
import Template from "./Template";
import * as firebase from "firebase";
import { auth } from "firebase";

export default class CustomExample extends Component {
  state = {
    globalData: [
      {
        name: "We Tu Lo",
        score: 200,
        iconUrl:
          "https://st2.depositphotos.com/1006318/5909/v/950/depositphotos_59094043-stock-illustration-profile-icon-male-avatar.jpg",
      },
      {
        name: "Adam Savage",
        score: 67,
        iconUrl:
          "https://www.shareicon.net/data/128x128/2016/09/15/829473_man_512x512.png",
      },
      {
        name: "Derek Black",
        score: 3,
        iconUrl:
          "http://ttsbilisim.com/wp-content/uploads/2014/09/20120807.png",
      },
      {
        name: "Erika White",
        score: 0,
        iconUrl:
          "http://www.lovemarks.com/wp-content/uploads/profile-avatars/default-avatar-eskimo-girl.png",
      },
      {
        name: "Jimmy John",
        score: 20,
        iconUrl: "https://static.witei.com/static/img/profile_pics/avatar4.png",
      },
      {
        name: "Joe Roddy",
        score: 17,
        iconUrl:
          "http://www.lovemarks.com/wp-content/uploads/profile-avatars/default-avatar-braindead-zombie.png",
      },
      {
        name: "Ericka Johannesburg",
        score: 101,
        iconUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShPis8NLdplTV1AJx40z-KS8zdgaSPaCfNINLtQ-ENdPvrtMWz",
      },
      {
        name: "Tim Thomas",
        score: 13,
        iconUrl:
          "http://conserveindia.org/wp-content/uploads/2017/07/teamMember4.png",
      },
      {
        name: "John Davis",
        score: 80,
        iconUrl:
          "https://cdn.dribbble.com/users/223408/screenshots/2134810/me-dribbble-size-001-001_1x.png",
      },

      {
        name: "Harry Reynolds",
        score: 100,
        iconUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsSlzi6GEickw2Ft62IdJTfXWsDFrOIbwXhzddXXt4FvsbNGhp",
      },
      {
        name: "Betty Davis",
        score: 25,
        iconUrl:
          "https://landofblogging.files.wordpress.com/2014/01/bitstripavatarprofilepic.jpeg?w=300&h=300",
      },
      {
        name: "Lauren Leonard",
        score: 30,
        iconUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSr27ZFBaclzKcxg2FgJh6xi3Z5-9vP_U1DPcB149bYXxlPKqv-",
      },
    ],
    friendData: [
      {
        name: "Joe Roddy",
        score: 67,
        iconUrl:
          "http://www.lovemarks.com/wp-content/uploads/profile-avatars/default-avatar-braindead-zombie.png",
      },
      {
        name: "Ericka Johannesburg",
        score: 101,
        iconUrl:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShPis8NLdplTV1AJx40z-KS8zdgaSPaCfNINLtQ-ENdPvrtMWz",
      },
      {
        name: "Tim Thomas",
        score: 41,
        iconUrl:
          "http://conserveindia.org/wp-content/uploads/2017/07/teamMember4.png",
      },
    ],
    filter: 0,
    userRank: 1,
    user: {
      name: "Joe Roddy",
      score: 67,
    },
  };

  sort = (data) => {
    const sorted =
      data &&
      data.sort((item1, item2) => {
        return item2.score - item1.score;
      });

    let userRank = sorted.findIndex((item) => {
      return item.name === this.state.user.name;
    });

    if (userRank === -1) {
      this.setState({ userRank: sorted.length + 1 });
    } else {
      this.setState({ userRank: userRank + 1 });
    }
    return sorted;
  };

  componentDidMount() {
    this.getUserLeaders();
  }

  getUserLeaders = () => {
    let globalData = [];

    firebase
      .database()
      .ref("leaderboard/weekly")
      .once("value")
      .then((snapshot) => {
        const users = snapshot.val();
        let allProfiles;
        firebase
          .database()
          .ref("profile")
          .once("value")
          .then((snapshot) => {
            allProfiles = snapshot.val();

            users.forEach((user) => {
              let uid = Object.keys(user)[0];
              let score = user[uid];

              if (allProfiles[uid] !== undefined) {
                globalData.push({
                  uid: uid,

                  name: allProfiles[uid]["displayName"],
                  score: score,
                  iconUrl: allProfiles[uid]["profilePic"],
                });
              } else {
                globalData.push({
                  uid: uid,
                  name: "someone",
                  score: 1,
                  iconUrl:
                    "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png",
                });
              }
            });
            console.log(globalData, auth().currentUser);

            let user = globalData.find(
              (obj) => obj["uid"] === auth().currentUser.uid
            );

            console.log(user);

            if (user === undefined) {
              user = {
                score: 0,
                name: auth().currentUser.displayName,
              };
              console.log(auth().currentUser)
              globalData.push({
                uid: auth().currentUser.uid,
                name: auth().currentUser.displayName,
                score: 0,
                iconUrl: auth().currentUser.photoURL,
              });
            }

            this.setState({
              user: user,
              globalData: globalData,
            });
          });
      });
    let friendData = [];

    firebase
      .database()
      .ref("leaderboard/allTime")
      .once("value")
      .then((snapshot) => {
        const users = snapshot.val();
        let allProfiles;
        firebase
          .database()
          .ref("profile")
          .once("value")
          .then((snapshot) => {
            allProfiles = snapshot.val();

            users.forEach((user) => {
              let uid = Object.keys(user)[0];
              let score = user[uid];

              if (allProfiles[uid] !== undefined) {
                friendData.push({
                  uid: uid,

                  name: allProfiles[uid]["displayName"],
                  score: score,
                  iconUrl: allProfiles[uid]["profilePic"],
                });
              } else {
                friendData.push({
                  uid: uid,
                  name: "someone",
                  score: 1,
                  iconUrl:
                    "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png",
                });
              }
            });

            this.setState({
              friendData: friendData,
            });
          });
      });
  };

  renderHeader = () => {
    return (
      <View
        style={{
          backgroundColor: "#011936",
          padding: 15,
          paddingTop: 35,
          alignItems: "center",
        }}
      >
        <Text style={{ fontSize: 25, color: "white" }}>Leaderboard</Text>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 15,
            marginTop: 20,
          }}
        >
          <Text
            style={{
              color: "white",
              fontSize: 25,
              flex: 1,
              textAlign: "right",
              marginRight: 40,
            }}
          >
            {ordinal_suffix_of(this.state.userRank)}
          </Text>
          {/* <Image
            style={{ flex: 0.66, height: 60, width: 60, borderRadius: 60 / 2 }}
            source={{
              uri:
                "http://www.lovemarks.com/wp-content/uploads/profile-avatars/default-avatar-braindead-zombie.png",
            }}
          /> */}

          <Text
            style={{ color: "white", fontSize: 25, flex: 1, marginLeft: 40 }}
          >
            {this.state.user.score}pts
          </Text>
        </View>
        <ButtonGroup
          onPress={(x) => {
            this.setState({ filter: x });
          }}
          selectedIndex={this.state.filter}
          buttons={["Last week", "All Time"]}
          containerStyle={{ height: 30 }}
        />
      </View>
    );
  };

  render() {
    return (
      <Template
        labelBy="name"
        sortBy="score"
        data={
          this.state.filter > 0 ? this.state.friendData : this.state.globalData
        }
        icon="iconUrl"
        onRowPress={(item, index) => {
          this.props.navigation.navigate("OtherProfile", {
            uid: item.uid,
            name: item.name,
            // data: item["item"]["name"],
          });
          // this.alert(item.name + " clicked", item.score + " points, wow!");
        }}
        sort={this.sort}
        renderHeader={this.renderHeader}
      />
    );
  }
}

const ordinal_suffix_of = (i) => {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
};
